import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { utils } from '@easygenerator/fragment-sdk';
import { LoggingType } from '@easygenerator/fragment-sdk/dist/utils/logger/constants';
import Config from '../config';

const config = Config.getInstance();
const logger = utils.Logger.getInstance();

export const ACTIVE_COURSE_LOADER = 'ACTIVE_COURSE_LOADER';
export const DISABLE_COURSE_LOADER = 'DISABLE_COURSE_LOADER';
export const SET_TOKEN_LEARN = 'SET_TOKEN_LEARN';
export const SET_USER_LOADING = 'SET_USER_LOADING';
export const RESET_TOKEN_LEARN = 'RESET_TOKEN_LEARN';

export class State {
  isLoading = true;

  userLoading = true;

  token = '';
}

const getters = {
  isLoading: state => state.isLoading,
  token: state => state.token,
  userLoading: state => state.userLoading
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as GetterTree<State, any>;

const mutations = {
  [ACTIVE_COURSE_LOADER](state: State) {
    state.isLoading = true;
  },
  [DISABLE_COURSE_LOADER](state: State) {
    state.isLoading = false;
  },

  [SET_TOKEN_LEARN](state: State, token: string) {
    state.token = token;
  },
  [RESET_TOKEN_LEARN](state: State) {
    state.token = '';
  },

  [SET_USER_LOADING](state: State, userLoading: boolean) {
    state.userLoading = userLoading;
  }
} as MutationTree<State>;

const actions = {
  async registerUser({ commit, dispatch }, { email, password, name }) {
    const { token } = await utils.HttpWrapper.post(`${config.authServiceUrl}/api/credentials/register`, {
      body: { email, password, name },
      fetchOptions: { credentials: 'include' }
    });
    if (token) {
      commit(SET_TOKEN_LEARN, token);
      dispatch('user/initUser', token, { root: true });
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  checkIfUserExists({ commit }, { email }) {
    return utils.HttpWrapper.get(`${config.authServiceUrl}/api/account/exists?email=${encodeURIComponent(email)}`);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async forgotPassword({ commit }, { email }) {
    await utils.HttpWrapper.post(`${config.authServiceUrl}/api/credentials/forgot-password`, {
      body: { email, returnUrl: config.learnServiceUrl }
    });
  },
  async authorize({ commit, dispatch }) {
    try {
      const { token } = await utils.HttpWrapper.get(`${config.authServiceUrl}/api/account/token`, {
        disableRedirects: true,
        fetchOptions: { credentials: 'include' }
      });
      if (token) {
        commit(SET_TOKEN_LEARN, token);
        dispatch('user/initUser', token, { root: true });
      }
    } catch {
      commit(RESET_TOKEN_LEARN);
    }
  },
  async login({ commit, dispatch }, { email, password, shortTermAccess }) {
    try {
      const { token } = await utils.HttpWrapper.post(`${config.authServiceUrl}/api/auth/credentials`, {
        body: { email, password, shortTermAccess },
        fetchOptions: { credentials: 'include' }
      });
      if (token) {
        commit(SET_TOKEN_LEARN, token);
        dispatch('user/initUser', token, { root: true });
      }
    } catch (error) {
      logger.trackError(LoggingType.warn, error);
      throw error;
    }
  },
  async logout({ commit }) {
    await utils.HttpWrapper.post(`${config.authServiceUrl}/api/account/logout`, {
      fetchOptions: {
        credentials: 'include'
      }
    });
    commit(ACTIVE_COURSE_LOADER);
    commit(RESET_TOKEN_LEARN);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as ActionTree<State, any>;

export default {
  namespaced: true,
  state: new State(),
  getters,
  mutations,
  actions
};
